import React from 'react';
import './styles.css';
import InvitationNotifcationPopUp from '../components/InvitationNotifcationPopUp';
import {Notification} from '../../../data/models/Notifications/Invitation';
import {notificationsText} from '../notificationsText';
import {notificationTimeTextConvertor} from '../../../utils/notificationTimeTextConvertor';

interface Props {
  notifications: Notification[];
  onViewAll: () => void;
  onViewCourse: (courseId: string, notificationId: string) => void;
  onViewWorkspace: (workspaceId: string, notificationId: string) => void;
  onViewCoursePreview: (
    courseId: string,
    workspaceId: string,
    notificationId: string,
  ) => void;
}

const NotificationsMenuPopUpUI = React.memo(
  ({
    notifications,
    onViewAll,
    onViewCourse,
    onViewWorkspace,
    onViewCoursePreview,
  }: Props) => {
    const renderNotifications = () => {
      if (notifications.length === 0) {
        return (
          <div className="EmptyState">
            <span className="icon-bell-filled"></span>
            <h3>{notificationsText.noNotifications}</h3>
          </div>
        );
      }
      return notifications.map((notification: Notification, index: number) => {
        const formattedDateSubtitle = notificationTimeTextConvertor(
          notification.dateCreated,
        );

        return (
          <li key={index}>
            <InvitationNotifcationPopUp
              description={notification.description}
              title={notification.title}
              dateSubtitle={formattedDateSubtitle}
              icon={notification.organizationAvatarUrl}
              type={notification.type}
              onViewCoursePreview={() =>
                onViewCoursePreview(
                  notification.entityId,
                  notification.organizationId!,
                  notification.id,
                )
              }
              onViewCourse={() =>
                onViewCourse(notification.entityId, notification.id)
              }
              onViewWorkspace={() =>
                onViewWorkspace(notification.organizationId!, notification.id)
              }
            />
          </li>
        );
      });
    };

    const onHandleViewAllClick = () => {
      onViewAll();
    };

    return (
      <div className="NotificationsMenuPopUpContainer">
        {notifications.length !== 0 && (
          <div className="HeadingText">{notificationsText.notifications} </div>
        )}
        <span className="popupArrowDetail"></span>
        <div className="NotificationsMenuPopUpBody">
          <ul>{renderNotifications()}</ul>
        </div>
        <button
          onClick={onHandleViewAllClick}
          className={
            notifications.length === 0
              ? 'ViewAllNotificationsButtonEmpty'
              : 'ViewAllNotificationsButton'
          }>
          {notificationsText.viewAll}
        </button>
      </div>
    );
  },
);

export default NotificationsMenuPopUpUI;
